import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { PromemoriaService } from 'src/app/core/promemoria.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-dialog-modal-promemoria',
  templateUrl: './dialog-modal-promemoria.component.html',
  styleUrl: './dialog-modal-promemoria.component.scss'
})
export class DialogModalPromemoriaComponent implements OnChanges {

  private readonly message = inject(MessageService);

  @Input() modaleVisibile: boolean = false;
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() promemoriaId?: number;
  @Input() testoEsistente?: string;

  @Output() closeDialog = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  testoPromemoria: string = '';

  constructor(private readonly promemoriaService: PromemoriaService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modaleVisibile']?.currentValue === true) {
      this.testoPromemoria = this.mode === 'edit' ? (this.testoEsistente ?? '') : '';
    }
  }

  actionPromemoria(): void {
    if (!this.testoPromemoria?.trim()) return;

    this.promemoriaService
      .savePromemoria(this.testoPromemoria, this.mode, this.promemoriaId)
      .subscribe({
        next: () => {
          this.message.add({
            severity: 'success',
            summary: 'Successo',
            detail: this.mode === 'create'
              ? 'Promemoria creato correttamente'
              : 'Promemoria modificato correttamente'
          });
          this.testoPromemoria = '';
          this.success.emit();
        },
        error: (err) => console.error(err)
      });
  }

  closeDialogEmit(): void {
    this.testoPromemoria = '';
    this.closeDialog.emit();
  }
}